module.exports = __webpack_public_path__ + "media/images/icons/icon-email-alpha-dcbe347f93f517957a76aac70eebacd9.svg";